var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01677 7.26108C0.90328 7.08138 0.846535 6.99153 0.81477 6.85295C0.79091 6.74885 0.79091 6.58468 0.81477 6.48059C0.846535 6.342 0.90328 6.25215 1.01677 6.07245C1.95461 4.58747 4.74617 0.833435 9.00034 0.833435C13.2545 0.833435 16.0461 4.58747 16.9839 6.07245C17.0974 6.25215 17.1541 6.342 17.1859 6.48059C17.2098 6.58468 17.2098 6.74885 17.1859 6.85295C17.1541 6.99153 17.0974 7.08138 16.9839 7.26108C16.0461 8.74607 13.2545 12.5001 9.00034 12.5001C4.74617 12.5001 1.95461 8.74607 1.01677 7.26108Z",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00034 9.16677C10.381 9.16677 11.5003 8.04748 11.5003 6.66677C11.5003 5.28606 10.381 4.16677 9.00034 4.16677C7.61962 4.16677 6.50034 5.28606 6.50034 6.66677C6.50034 8.04748 7.61962 9.16677 9.00034 9.16677Z",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye-on.8f624eb156acf15dc2195d70af0a081e.svg";
export { ForwardRef as ReactComponent };